{
  "name": "@ns/company-relationship-end",
  "version": "1.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Confirm ending a commercial relationship",
  "inputs": {
    "relationshipId": {
      "type": "string"
    }
  },
  "outcomes": {
    "confirm": {},
    "cancel": {}
  }
}
